import { Fragment } from 'react/jsx-runtime';
import { StyledStack } from './styles';
import { forwardRef } from 'react';

type Props<T> = {
  files: Array<T>;
  renderIcon: (file: T) => React.ReactNode;
};

function FilePreviews<T>(
  { files, renderIcon }: Props<T>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  if (files.length === 0) return;

  return (
    <StyledStack ref={ref}>
      {files.map((file, index) => (
        <Fragment key={index}>{renderIcon(file)}</Fragment>
      ))}
    </StyledStack>
  );
}

FilePreviews.displayName = 'SearchWidget.FilePreviews';

export default forwardRef(FilePreviews) as <T>(
  props: Props<T> & { ref?: React.ForwardedRef<HTMLUListElement> },
) => ReturnType<typeof FilePreviews>;
